import { useEffect } from "react";
import { QuoteRequestForm } from "../components/QuoteRequestForm";

export default function QuotePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FBEFEF] pt-20">
      <div className="mx-auto w-full max-w-3xl px-4 py-10 md:py-16">
        <header className="mx-auto max-w-2xl text-center">
          <p className="text-xs uppercase tracking-[0.32em] text-[#B87775]">
            Request a quote
          </p>
          <h1 className="mt-3 font-serif text-3xl leading-tight text-[#3a2e2c] md:text-5xl">
            Tell us about your day
          </h1>
          <p className="mt-4 text-base leading-relaxed text-[#7c6c6a] md:text-lg">
            Share a few details and we'll send a personalised quote with pricing
            and availability — usually within 24 hours.
          </p>
        </header>

        <div className="mt-10">
          <QuoteRequestForm />
        </div>
      </div>
    </div>
  );
}
